import { render } from "./ComplianceDocuments.vue?vue&type=template&id=d421e544"
import script from "./ComplianceDocuments.vue?vue&type=script&lang=js"
export * from "./ComplianceDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__